import { render } from "./ContactCoach.vue?vue&type=template&id=71a6d754&scoped=true"
import script from "./ContactCoach.vue?vue&type=script&lang=js"
export * from "./ContactCoach.vue?vue&type=script&lang=js"

import "./ContactCoach.vue?vue&type=style&index=0&id=71a6d754&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ACER\\Desktop\\Vue Course\\Main Course Project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71a6d754"]])

export default __exports__